module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Black-Beauty.53a5d7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Black-Beauty.jpg
// module id = jhQO
// module chunks = 0